export default {
  install(Vue, runtimeConfigurationOptions) {
    let runtimeConfigurationOptionsJson = runtimeConfigurationOptions.configuration;

    var mixin = {
      data() {
        return {
          RCEnvironment: {
            VUE_APP_ENVIRONMENT: runtimeConfigurationOptionsJson.VUE_APP_ENVIRONMENT,
            VUE_APP_IS_PROD: runtimeConfigurationOptionsJson.VUE_APP_IS_PROD,
            VUE_APP_FRONT_URL: runtimeConfigurationOptionsJson.VUE_APP_FRONT_URL,
            VUE_APP_ACCOUNT_URL: runtimeConfigurationOptionsJson.VUE_APP_ACCOUNT_URL,
            VUE_APP_MEDIAS_URL: runtimeConfigurationOptionsJson.VUE_APP_MEDIAS_URL,
            VUE_APP_ACCOUNT_API_URL: runtimeConfigurationOptionsJson.VUE_APP_ACCOUNT_API_URL,
            VUE_APP_ACCOUNT_API_KEY: runtimeConfigurationOptionsJson.VUE_APP_ACCOUNT_API_KEY,
            VUE_APP_API_KEY: runtimeConfigurationOptionsJson.VUE_APP_API_KEY,
            VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY: runtimeConfigurationOptionsJson.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
            VUE_APP_PARTNER_NAME: runtimeConfigurationOptionsJson.VUE_APP_PARTNER_NAME,
            VUE_APP_REGISTER_STUDIO_NAME: runtimeConfigurationOptionsJson.VUE_APP_REGISTER_STUDIO_NAME,
            VUE_APP_REGISTER_WITH_ACCESS_KEYS: runtimeConfigurationOptionsJson.VUE_APP_REGISTER_WITH_ACCESS_KEYS,
            VUE_APP_ENABLE_RECAPTCHA: runtimeConfigurationOptionsJson.VUE_APP_ENABLE_RECAPTCHA,
            VUE_APP_ENABLE_CONNECTIONS_SECTION: runtimeConfigurationOptionsJson.VUE_APP_ENABLE_CONNECTIONS_SECTION,
            VUE_APP_ENABLE_NEWSLETTER_SECTION: runtimeConfigurationOptionsJson.VUE_APP_ENABLE_NEWSLETTER_SECTION,
            VUE_APP_ENABLE_DELETION_SECTION: runtimeConfigurationOptionsJson.VUE_APP_ENABLE_DELETION_SECTION,
            VUE_APP_BYPASS_PARTNER_REGISTER_PAGE: runtimeConfigurationOptionsJson.VUE_APP_BYPASS_PARTNER_REGISTER_PAGE,
            VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT: runtimeConfigurationOptionsJson.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT,
            VUE_APP_GOOGLE_TAG_MANAGER: runtimeConfigurationOptionsJson.VUE_APP_GOOGLE_TAG_MANAGER,
            VUE_APP_USE_SEGA_REDEEMER: runtimeConfigurationOptionsJson.VUE_APP_USE_SEGA_REDEEMER,
            VUE_APP_PLATFORM_NAME: runtimeConfigurationOptionsJson.VUE_APP_PLATFORM_NAME,
            VUE_APP_SUPPORT_TEAM_EMAIL: runtimeConfigurationOptionsJson.VUE_APP_SUPPORT_TEAM_EMAIL,
            VUE_APP_ACCOUNT_TERMS_LINK: runtimeConfigurationOptionsJson.VUE_APP_ACCOUNT_TERMS_LINK,
            VUE_APP_PRIVACY_POLICY_LINK: runtimeConfigurationOptionsJson.VUE_APP_PRIVACY_POLICY_LINK,
            VUE_APP_COOKIES_POLICY_LINK: runtimeConfigurationOptionsJson.VUE_APP_COOKIES_POLICY_LINK,
          }
        }
      },
    };

    Vue.mixin(mixin);
  },
};
